<!-- Download Agreement Modal -->
<div class="modal-header gtm-download-agreement selenium-download-agreement pb-2">
    <h5 *ngIf="isDownloadReady" class="modal-title">Download Agreement</h5>
    <h5 *ngIf="!isDownloadReady" class="modal-title">Information</h5>
    <button
        (click)="activeModal.dismiss('Cross click')"
        aria-label="Close"
        class="btn-close"
        data-dismiss="modal"
        type="button"
    ></button>
</div>
<div *ngIf="isDownloadReady" class="agreement-modal modal-body-text">
    <div class="mb-1 media-details">
        <div class="pe-2"><span>File size: </span>{{ fileSize }}</div>
        <div><span>File type: </span>{{ fileType }}</div>
    </div>
    <input (click)="updateAgreementState()" type="checkbox" />
    <span class="ps-2 pe-1 mandatory-check">*</span>
    I have read and accept the terms and conditions as
    <a
        href="/help/full-license-for-section-3c-of-terms-of-use-download-and-share/"
        rel="noopener noreferrer"
        target="_blank"
        >outlined in this license.</a
    >
</div>

<div *ngIf="!isDownloadReady">
    <div class="mb-1 media-details">
        <p class="pt-4 modal-body-text">
            Your download is being prepared. Please try again in a few minutes.
        </p>
    </div>
</div>

<div class="modal-footer pt-2">
    <button
        (click)="activeModal.dismiss('Cross click')"
        class="btn secondary-button selenium-download-close"
        type="button"
    >
        {{ (isDownloadReady && "Cancel") || "OK" }}
    </button>
    <a
        (click)="$event.preventDefault(); onDownloadClick()"
        *ngIf="isDownloadReady"
        href="#"
        [ngClass]="{
            'primary-disabled': !isAgreementChecked,
            'btn-outline-primary': isAgreementChecked,
        }"
        class="btn selenium-download-accept"
        >Download
    </a>
</div>
